module.exports = __webpack_public_path__ + "static/media/sort_icon.2c94ced6.svg";